export default function FrontConfigEditModal({
  open,
  title,
  children,
  submitting,
  onSubmit,
  onReset,
  onClose,
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        aria-labelledby="front-config-edit-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="admin-modal__header">
          <h3 id="front-config-edit-title">{title}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose} aria-label="關閉">
            ×
          </button>
        </header>
        <div className="admin-modal__body admin-modal__body--form">{children}</div>
        <footer className="admin-modal__footer admin-modal__footer--center">
          <button type="button" className="btn btn-primary" disabled={submitting} onClick={onSubmit}>
            {submitting ? '提交中…' : '提交'}
          </button>
          <button type="button" className="btn btn-warning" disabled={submitting} onClick={onReset}>
            重置
          </button>
          <button type="button" className="btn btn-danger" disabled={submitting} onClick={onClose}>
            關閉
          </button>
        </footer>
      </div>
    </div>
  );
}
